import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getPlatformAttentionSettings,
  updatePlatformAttentionSettings,
} from '@/lib/recepthor-api';
import { qk } from '@/lib/queryKeys';

export function usePlatformAttentionSettings({ organizationId, enabled }) {
  return useQuery({
    queryKey: qk.platformAttention(organizationId),
    queryFn: () => getPlatformAttentionSettings({ organizationId }),
    enabled: enabled && organizationId != null,
  });
}

export function useUpdatePlatformAttentionSettings({ organizationId }) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (ids) =>
      updatePlatformAttentionSettings(ids, { organizationId }),
    onSuccess: (data) => {
      // A 204 carries no body: keep the cache and let the refetch fill it.
      if (data != null) {
        client.setQueryData(qk.platformAttention(organizationId), data);
      }
      return client.invalidateQueries({ queryKey: qk.platformAttentionAll() });
    },
  });
}
